import React, { useState, useEffect, useRef } from 'react';
import { Tabs, Button, Form, Input, Spin } from 'antd';
import { CheckCircleOutlined, HomeOutlined } from '@ant-design/icons';
import Message from '../../component/message/message';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import trans from './translation';
import './testTurnitin.css';
const { TabPane } = Tabs;
const TestTurnitin = (props) => {

    const [form] = Form.useForm();
    const messageRef = useRef();
    const [tabIndex, setTabIndex] = useState("1");
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");

    useEffect(() => {
        searchById();
    }, []);

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            apiUrl: model.apiUrl ?? "",
            apiKey: model.apiKey ?? "",
        });
    }

    const onFinish = (values) => {
        messageShowHandler();
        setIsLoad(true);
        setSpinInfo(trans.dataBeSaving[Config.backLang])
        values.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi('testTurnitin/testConnection', values).then((data) => {
            if ("SUCCESS" === data.msg) {
                errFrameShow("success", trans.testConnetionSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => {
            setIsLoad(false);
        });
    }

    const searchById = () => {
        setIsLoad(true);
        Base.callBackApi("testTurnitin/searchById").then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data?.object ?? {};
                initForm(model);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    return (
        <div id="container" className="template testTurnitin">
            <div className='breadcrumb'>
                <HomeOutlined /> / System / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : '')]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin size="large" spinning={isLoad} tip={spinInfo}>
                    <Form form={form} onFinish={onFinish}>
                        <div className='sysRow'>
                            <div className='sysColMax'>
                                <div className="sysParam mustFill">{trans.apiUrl[Config.backLang]}</div>
                                <div className="sysInputMax">
                                    <Form.Item
                                        name="apiUrl"
                                        rules={[
                                            { required: true, message: trans.apiUrlNoIsNull[Config.backLang] },
                                        ]}
                                    >
                                        <Input type="text" placeholder={trans.apiUrl[Config.backLang]} maxLength={100} />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className='sysRow'>
                            <div className='sysColMax'>
                                <div className="sysParam mustFill">{trans.apiKey[Config.backLang]}</div>
                                <div className="sysInputMax">
                                    <Form.Item
                                        name="apiKey"
                                        rules={[
                                            { required: true, message: trans.apiKeyNoIsNull[Config.backLang] },
                                        ]}
                                    >
                                        <Input type="text" placeholder={trans.apiKey[Config.backLang]} maxLength={100} />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className="sysSaveButton">
                            <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} icon={<CheckCircleOutlined />} htmlType="submit">{trans.testConnetion[Config.backLang]}</Button>
                        </div>
                    </Form>
                </Spin>
            </div>
        </div>
    )

}

export default TestTurnitin;